export const IconTelehealthPhone = (props: JSX.IntrinsicElements['svg']) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.7273 0H3.27273C2.40475 0 1.57232 0.387441 0.95856 1.07709C0.344804 1.76674 0 2.70211 0 3.67742V34.3226C0 35.2979 0.344804 36.2333 0.95856 36.9229C1.57232 37.6126 2.40475 38 3.27273 38H20.7273C21.5953 38 22.4277 37.6126 23.0414 36.9229C23.6552 36.2333 24 35.2979 24 34.3226V3.67742C24 2.70211 23.6552 1.76674 23.0414 1.07709C22.4277 0.387441 21.5953 0 20.7273 0ZM22.9091 32.4839C22.9091 32.6464 22.8516 32.8023 22.7493 32.9173C22.647 33.0322 22.5083 33.0968 22.3636 33.0968H1.63636C1.4917 33.0968 1.35296 33.0322 1.25067 32.9173C1.14838 32.8023 1.09091 32.6464 1.09091 32.4839V4.29032C1.09091 4.12777 1.14838 3.97188 1.25067 3.85693C1.35296 3.74199 1.4917 3.67742 1.63636 3.67742H22.3636C22.5083 3.67742 22.647 3.74199 22.7493 3.85693C22.8516 3.97188 22.9091 4.12777 22.9091 4.29032V32.4839Z"
      fill="#6A7B7D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0384 13C9.76229 13 9.53843 13.2239 9.53843 13.5V16.5384H6.5C6.22386 16.5384 6 16.7622 6 17.0384V20.9614C6 21.2376 6.22386 21.4614 6.5 21.4614H9.53843V24.5C9.53843 24.7761 9.76229 25 10.0384 25H13.9615C14.2377 25 14.4615 24.7761 14.4615 24.5V21.4614H17.5C17.7761 21.4614 18 21.2376 18 20.9614V17.0384C18 16.7622 17.7761 16.5384 17.5 16.5384H14.4615V13.5C14.4615 13.2239 14.2377 13 13.9615 13H10.0384Z"
      fill="#6A7B7D"
    />
  </svg>
);
